import React from 'react';
import _ from 'lodash';
import { Collapse } from 'reactstrap';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import Loader from 'app/components/general/Loader';
import SectionTitle from 'app/components/general/SectionTitle';

interface ISectionGroupProps {
  children: React.ReactNode;
  buttons: React.ReactNode;
  title: string;
  notification: string;
  className: string;
  collapseable: boolean;
  isLoading: boolean;
  noBorder: boolean;
  count: number;
  handleEdit: Function;
}

interface ISectionGroupState {
  isOpen: boolean;
}
export default class SectionGroup extends React.Component<ISectionGroupProps> {
  static defaultProps: ISectionGroupProps = {
    children: undefined,
    title: undefined,
    className: undefined,
    notification: undefined,
    buttons: undefined,
    handleEdit: undefined,
    collapseable: false,
    isLoading: false,
    noBorder: false,
    count: 5,
  };

  state: ISectionGroupState = {
    isOpen: true,
  };

  toggleOpen = (): void => {
    this.setState((prevState: ISectionGroupState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  render(): React.ReactNode {
    if (this.props.collapseable) {
      return (
        <div className={classnames('section-group collapseable', this.props.className, {
          'is-open': this.state.isOpen,
        })}
        >
          {!_.isEmpty(this.props.title) && (
            <SectionTitle
              notification={this.props.notification}
              onClick={this.toggleOpen}
              withArrow
              isOpen={this.state.isOpen}
              buttons={this.props.buttons}
              noBorder={this.props.noBorder}
            >
              {this.props.title}
            </SectionTitle>
          )}
          <Collapse isOpen={this.state.isOpen}>
            <div className="section-body">{this.props.children}</div>
          </Collapse>
        </div>
      );
    }
    return (
      <div className={classnames('section-group', this.props.className)}>
        {!_.isEmpty(this.props.title) && (
          <SectionTitle
            notification={this.props.notification}
            buttons={this.props.buttons}
            noBorder={this.props.noBorder}
            titleLink={this.props.handleEdit !== undefined && (
              <a className="section-edit primary" onClick={this.props.handleEdit}>Edit</a>
            )}
          >
            {this.props.title}
          </SectionTitle>
        )}
        {this.props.isLoading && (
          <Loader skeleton count={this.props.count} isActive color="grey" />
        )}
        <div className={classnames('section-body', { 'd-none': this.props.isLoading })}>{this.props.children}</div>
      </div>
    );
  }
}
